import {useContext, useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import {CampaignTableRow} from './CampaignTableRow';
import {BasicTable, TableColumn} from '../../../../components/BasicTable/BasicTable';
import {createBasicTableColumn} from '../../../../components/BasicTable/createBasicTableColumn';
import {CompanyContext} from '../../../../contexts/CompanyContext/CompanyContext';
import {Campaign} from '../../../../types/Campaign';

type RowProps = {campaign: Campaign; companyName: string; id: string};

interface Props {
  campaigns: Campaign[];
}

export const CampaignsTable = ({campaigns}: Props) => {
  const {t} = useTranslation();
  const {company} = useContext(CompanyContext);
  const columns = useMemo((): TableColumn[] => {
    return [
      createBasicTableColumn('analytics', ''),
      createBasicTableColumn('name', t('campaignsPage.tableHeaders.name')),
      createBasicTableColumn(
        'status',
        t('campaignsPage.tableHeaders.status', {
          maxWidth: '50px',
        })
      ),
      createBasicTableColumn('dateRange', t('campaignsPage.tableHeaders.dateRange'), {
        sortable: true,
        getSortValue: (row: any) => row?.campaign.dateRange?.startDate,
      }),
      createBasicTableColumn('matches', t('campaignsPage.tableHeaders.matches'), {
        sortable: true,
        getSortValue: (row: any) => row?.campaign?.matches?.total,
      }),
      createBasicTableColumn('button', ''),
    ];
  }, [t]);

  const rowData = campaigns.map((campaign) => ({
    campaign,
    id: campaign.resourceId,
    companyName: company?.data?.name || '',
  }));

  return <BasicTable<RowProps> columns={columns} Row={CampaignTableRow} rowData={rowData} />;
};
